module.exports = __webpack_public_path__ + "static/media/auth_2.491ca33c.jpg";